import React from "react";
import { useParams } from "react-router-dom";
import firebase from "firebase/compat";
import { Grid } from "@mui/material";
import CatalogueContents from "./CatalogueContents";
import { AuthError } from "../Error/AuthError";
import { useAuthContext } from "../../Modules/Auth/AuthContext";
import { db } from "../../Environment/firebase";

export default function CatalogueAuthSelect(){

    const { uploaderId,CatalogueId } = useParams();
    const { userData } = useAuthContext();

    const [catalogueData, setCatalogueData] = React.useState<firebase.firestore.DocumentData>({});
    const [show,setShow] = React.useState(false);

    let CatalogueContentsBase: JSX.Element = <div></div>;

    React.useEffect(() => {
        db.collection("dwh")
            .doc(CatalogueId)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    const docx = doc.data();
                    if(docx){
                        setCatalogueData(docx);
                    setShow(true);
                    }
                    
                } else {
                }
            })
    }, [CatalogueId]);

    switch (catalogueData.share){
        case 'true':
            CatalogueContentsBase = <CatalogueContents catalogueData = {catalogueData}></CatalogueContents>;
            break;
        case 'url':
            CatalogueContentsBase = <CatalogueContents catalogueData = {catalogueData}></CatalogueContents>;
            break;
        case 'mnist':
            if(userData?.email.includes('@mnes.org') || userData?.email.includes('@kasumiclinic.jp')){
                CatalogueContentsBase = <CatalogueContents catalogueData = {catalogueData}></CatalogueContents>;
            }else{
                CatalogueContentsBase = <AuthError></AuthError>
            }
            break;
        default:
            CatalogueContentsBase = <AuthError></ AuthError>
    }

    return (
        <div>
            {show === true ? CatalogueContentsBase:
            <Grid>
                Now Loading...
            </Grid>}
        </div>
        
    )

}